import { render } from "./LiveBanner.vue?vue&type=template&id=6e704378&scoped=true&lang=pug"
import script from "./LiveBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveBanner.vue?vue&type=script&setup=true&lang=js"

import "./LiveBanner.vue?vue&type=style&index=0&id=6e704378&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e704378"]])

export default __exports__